<template>
  <div class="main">
    <div class="col-gauche">
      <img src="../assets/overlayLogin.png" alt="image emotion culturel" />
    </div>
    <div class="col-droite">
      <form @submit="onSubmit">
        <div class="field" v-if="send === false">
          <label for="courriel">Récupération par courriel</label>
          <input
            type="email"
            v-model="form.email"
            name="courriel"
            id="courriel"
            placeholder="Récupération par courriel"
            required
          />
        </div>
        <input class="btn-submit" type="submit" value="Envoyer" v-if="send === false"/>
        <p>
          <br>
          <a
            @click="toSignin"
            class="link"
            >Retour à la page de connexion
          </a>
        </p>

        <div class="information" style="display:block" v-if="send === true">
          <p class="success">Envoyé avec succès</p>
          </br>
          </br>
          <p>
            Un courriel vous a été envoyé avec votre nom d’usager et un lien qui
            vous permettra de définir votre nouveau mot de passe. Si vous n’avez
            pas reçu ce courriel, <a class="link" @click="resentEmail({email:form.email})">cliquez ici</a> pour en recevoir
            un à nouveau.
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      form: {},
      send:false,
    };
  },
  watch:{
    sendRequestResetMail(){
      if(this.sendRequestResetMail){
        this.send = true;
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      sendRequestResetMail: (state) => state.auth.sendRequestResetMail,
    }),
  },
  methods: {
    ...mapActions(["requestReset","resentEmail"]),
    onSubmit(event) {
      event.preventDefault();
      this.requestReset(this.form);
    },
    toSignin() {
      this.$router.push({
        name: "Signin",
      });
    },
  },
};
</script>

<style scoped src="../assets/styleLogin.css">
</style>
